import { Controller } from "react-hook-form"
import Autocomplete from "@material-ui/lab/Autocomplete"

export const InputBox = ({usage, type, id, placeholder, value, onChange}) => {
  if (type === undefined) type = 'text'
  return (
    <div className={`${usage}_input`}>
      <input type={type} id={id} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  )
}

export const TextButton = ({usage, href, onClick, text}) => {
  if (href !== undefined) {
    return (
      <a href={href}><div className={`btn_${usage}`} onClick={onClick}>{text}</div></a>
    )
  } else {
    return (
      <a><div className={`btn_${usage}`} onClick={onClick}>{text}</div></a>
    )
  }
}

export const MessageModal = ({visible, setVisible, type, message, title=undefined}) => {
  let defaultTypes = {
    success: {title: title? title:'Success', color: '#28a745'},
    error: {title: title? title:'Error', color: '#dc3545' },
    warning: {title: title? title:'Warning', color: '#ffc107'},
    info: {title: title? title:'Information', color: '#17a2b8'}
  }

  const handleHideModal = () => {setVisible(false)}

  return (
    <div className="modal_bkg" style={visible? {}:{display: 'none'}}>
      <div className="modal_body">
        <span className="modal_title" style={{color: defaultTypes[type]? defaultTypes[type].color:defaultTypes['info'].color}}>
          {defaultTypes[type]? defaultTypes[type].title:defaultTypes['info'].title}
        </span>
        <div className="modal_sep_line" />
        <span className="modal_message">
          {message}
        </span>
        <div className="modal_buttons">
          <button type="button" onClick={handleHideModal}>OK</button>
        </div>
      </div>
    </div>
  )
}

export const FormAutoCompleteBox = ({ control, options, box_class, fname, team }) => {
  return (
    <Controller
      render={(props) => (
        <Autocomplete
          value={props.field.value}
          className={box_class}
          options={team===undefined? options:options.filter((e=>e.team===team))}
          size="small"
          freeSolo
          ListboxProps={{style: {overflow: 'hidden'}}}
          getOptionLabel={(option) => option.label}
          renderOption={(option) => (
            <span style={{ fontSize: "1.5rem" }}>
              {option.label}
              <span style={{ color: "#777", fontSize: "1.1rem" }}>
                {" "}
                {option.team} {option.number}
              </span>
            </span>
          )}
          renderInput={(params) => (
            <div ref={params.InputProps.ref}>
              <input type="text" {...params.inputProps} />
            </div>
          )}
          onChange={(e, data) => {props.field.onChange(data)}}
          {...props}
        />
      )}
      onChange={([, data]) => data}
      name={fname}
      control={control}
    />
  )
}